import { render, staticRenderFns } from "./ChemMcM1AA3Lab10Report1.vue?vue&type=template&id=b97651f2&"
import script from "./ChemMcM1AA3Lab10Report1.vue?vue&type=script&lang=ts&"
export * from "./ChemMcM1AA3Lab10Report1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VContainer,VRow,VSimpleTable,VTextarea})
